import toast from 'react-hot-toast';
import api from "../Crypto/axios.js";

export const FETCH_ALL_PARTNERS = 'FETCH_ALL_PARTNERS';
export const ADD_NEW_PARTNERS = 'ADD_NEW_PARTNERS';
export const SET_SELECTED_PARTNERS_ROW = 'SET_SELECTED_PARTNERS_ROW';
export const RESET_SELECTED_PARTNERS_ROW = 'RESET_SELECTED_PARTNERS_ROW';
export const CLEAR_DATA = 'CLEAR_DATA';
export const STATUS_UPDATED = 'STATUS_UPDATED';
export const FETCH_ALL_PARTNERS_ONLY = 'FETCH_ALL_PARTNERS_ONLY';

const initialState = {
  allPartners: [],
  allPartnersOnly: [],
  newPartners: [],
  selectedPartnersRow: {},
  statusUpdate: {},
};

const PartnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PARTNERS:
      return {
        ...state,
        allPartners: action.payload,
      };
    case FETCH_ALL_PARTNERS_ONLY:
      return {
        ...state,
        allPartnersOnly: action.payload,
      };
    case ADD_NEW_PARTNERS:
      return {
        ...state,
        newPartners: action.payload,
      };
    case SET_SELECTED_PARTNERS_ROW:
      return {
        ...state,
        selectedPartnersRow: action.payload,
      };
    case RESET_SELECTED_PARTNERS_ROW:
      return {
        ...state,
        selectedPartnersRow: {},
      };
    case STATUS_UPDATED:
      return {
        ...state,
        statusUpdate: {},
      };
    case CLEAR_DATA:
      return {
        ...state,
        allPartners: [],
        error: null,
      };
    default:
      return state;
  }
};

export default PartnersReducer;

export const fetchAllPartners = (data) => ({
  type: FETCH_ALL_PARTNERS,
  payload: data,
});
export const fetchAllPartnersOnly = (data) => ({
  type: FETCH_ALL_PARTNERS_ONLY,
  payload: data,
});
export const addNewPartners = (data) => ({
  type: ADD_NEW_PARTNERS,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedPartnersRow = (data) => ({
  type: SET_SELECTED_PARTNERS_ROW,
  payload: data,
});
export const resetSelectedPartnersRow = () => ({
  type: RESET_SELECTED_PARTNERS_ROW,
  // payload: data,
});
export const statusUpdate = (data) => ({
  type: STATUS_UPDATED,
});

export const getAllPartners = (adminId) => {
  return async (dispatch) => {
    const promise = api
      .get(`/nrcb/ecom/get/partner/${adminId}`, { requiresAuth: true })
      .then((response) => {
        dispatch(fetchAllPartners(response));
        return response;
      });
    return promise.catch(() => {
      return { status: 'error', message: 'Failed to fetch partners' };
    });
  };
};

export const addPartners = (adminId, newPartner) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/new/partner/${adminId}`, newPartner, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(addNewPartners(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Adding New Partners...',
      success: 'New Partners Added',
      error: (error) => {
        console.error('Failed to add partners:', error);
        return error.response?.data?.message || 'Failed to add Partners';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to add partners' };
    });
  };
};

export const statusPartners = (data, adminId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/status/partners/${adminId}`, data, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(statusUpdate(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Processing...',
      success: (res) => `Partner: ${res?.message}`,
      error: (error) => {
        console.error('Failed to update partner status:', error);
        return error.response?.data?.message || 'Failed';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to update partner status' };
    });
  };
};

export const editPartners = (adminId, updatedPartner, partnerId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/edit/partners/${adminId}/${partnerId}`, updatedPartner,{requiresAuth:true})
      .then((response) => {
        dispatch(addNewPartners(response));
        dispatch(resetSelectedPartnersRow());
        return response;
      })
      .catch((error) => {
        console.error('Error:', error);
        throw new Error(error.message || 'Failed to edit data');
      });

    toast.promise(promise, {
      loading: 'Editing data...',
      success: 'Successfully Edited',
      error: 'Failed to edit data',
    });

    return promise;
  };
};

export const getPartnersOnly = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/nrcb/ecom/get/partnersonly`);
      dispatch(fetchAllPartnersOnly(response));
    } catch (error) {
      if (error?.response?.status === 404) {
        dispatch(clearData());
      } else {
        console.error('Failed to fetch Partners:', error);
      }
    }
  };
};
